// extracted by mini-css-extract-plugin
module.exports = {"container":"stars-module__container___HtCoa","icon":"stars-module__icon___PMnFo","hide":"stars-module__hide___kE6bL"};